const getters = {
  getReferralCurrentFilters: state => state.referral.currentFilters,
  getReferralResults: state => state.referral.results,
  getReferralPaging: state => state.referral.paging,
  getAcademicYears: state => state.referral.filters.academicyears,
  getSelectedAcademicYear: state => state.referral.filters.selectedAcademicYear,
  getSelectedFilterType: state => state.referral.filters.selectedFilterType,
  getServiceCenter: state => state.referral.serviceCenters,
  getDisciplines: state => state.referral.filters.disciplines,
  filters: (state, getters, rootState, rootGetters) => {
    const isWaitingList = rootGetters["$_user/hasPermissions"](
      "referredmanagement.waitingList"
    );
    if (!isWaitingList) {
      return state.referral.filters.filters.filter(f => f.id !== 4);
    }
    return state.referral.filters.filters;
  },
  getReferralRejectionReasons: state => state.referral.rejectionReasons
};

export default getters;
